/* Where layers sit in the stack.
 *
 * Two numbers, in their own file, because App needs EndIndex and nothing else
 * from structure/Layer.js — and importing it for that pulled react-draggable,
 * views/Main and lottie-web into the bundle every visitor downloads. A constant
 * should never be able to cost a megabyte, and it can whenever it lives in the
 * same module as the machinery.
 *
 * Layer.js re-exports both so nothing that already imports them from there has
 * to change.
 */
export const EndIndex = 4990;
export const FrontIndex = EndIndex + 10;
